import { Smartphone, Car, Bike, Sofa, Tv, Building2, Briefcase, Wrench, Wheat, LandPlot, House, Store, KeyRound } from "lucide-react";

export const CATEGORY_INFO = {
  Property: { icon: Building2, mr: "प्रॉपर्टी", color: "#00796B", bg: "#E0F2EF" },
  Mobile: { icon: Smartphone, mr: "मोबाईल", color: "#1565C0", bg: "#E3EEFC" },
  Car: { icon: Car, mr: "कार", color: "#E53935", bg: "#FDE8E8" },
  Bike: { icon: Bike, mr: "बाईक", color: "#FF7A00", bg: "#FFF0E0" },
  Furniture: { icon: Sofa, mr: "फर्निचर", color: "#8D5524", bg: "#F6ECE2" },
  Electronics: { icon: Tv, mr: "इलेक्ट्रॉनिक्स", color: "#6A1B9A", bg: "#F1E6F7" },
  Jobs: { icon: Briefcase, mr: "नोकरी", color: "#0A2A66", bg: "#E4E9F3" },
  Services: { icon: Wrench, mr: "सेवा", color: "#C2185B", bg: "#FBE4EE" },
};

export const CATEGORIES = Object.keys(CATEGORY_INFO);
export const QUICK_DISTRICTS = ["Nanded", "Latur", "Pune", "Mumbai City", "Mumbai Suburban"];

export const PROPERTY_TYPES = {
  farmland: { mr: "शेतजमीन", en: "Sheti Jamin", icon: Wheat, color: "#2E7D32", bg: "#E8F5E9" },
  plot: { mr: "प्लॉट", en: "Plot", icon: LandPlot, color: "#8D5524", bg: "#F6ECE2" },
  house: { mr: "घर विकणे", en: "Ghar", icon: House, color: "#1565C0", bg: "#E3EEFC" },
  shop: { mr: "दुकान", en: "Shop", icon: Store, color: "#C2185B", bg: "#FBE4EE" },
  rent: { mr: "भाड्याने देणे", en: "Rent", icon: KeyRound, color: "#FF7A00", bg: "#FFF0E0" },
};

export const AREA_UNITS = { guntha: "गुंठे", acre: "एकर", sqft: "Sq Ft" };

export const formatArea = (ad) => (ad.area ? `${Number(ad.area).toLocaleString("en-IN")} ${AREA_UNITS[ad.area_unit] || ""}` : null);
